import TableLoader from "../../../../../general/table/tableLoader";
import EmptyRow from "../../../../../general/table/emptyRow";
import React from "react";
import {Accordion} from "react-bootstrap";
import VisitMedicationPrescriptionCardsItem from "./visitMedicationPrescriptionCards_Item";
type VisitMedicationPrescriptionCardsProps = {
  dataList?: any;
  dataListTitles: string[];
  isRequesting: boolean
}

const VisitMedicationPrescriptionCards = ({
  dataList,
  dataListTitles,
  isRequesting
}: VisitMedicationPrescriptionCardsProps) => {

  const _dataList = dataList && dataList.length > 0 && dataList.map((item: any, i: number) => {
    return <VisitMedicationPrescriptionCardsItem item={item} key={i} index={i}/>
  });

  return (
    isRequesting ?
      <TableLoader colSpan={dataListTitles.length}/> :
      _dataList ? <Accordion className='prescription-items-accordion rounded mx-1'> {_dataList} </Accordion> :
        <EmptyRow colSpan={dataListTitles.length} content={''}/>
  )
}

export default VisitMedicationPrescriptionCards;
